import endpoint from "../../../../config/endpoints";
import { apiPost } from "../../../../utils/api_service";

// Build POST body for purchase-order load sheet SKU-wise API.
export const buildPurchaseOrderSkuWisePostBody = () => {
  const lang = localStorage.getItem("lang");
  const loadSheetStockHolderOrderID = localStorage.getItem(
    "loadSheetStockHolderOrderID"
  );

  return {
    stockStakeHolderOrderHeaderIds: loadSheetStockHolderOrderID.split(","),
    languageId: lang,
  };
};

export const fetchPurchaseOrderSkuWise = async () => {
  const postBody = buildPurchaseOrderSkuWisePostBody();
  return apiPost({
    url: endpoint.stockStakeholderOrderHeader + "/load-sheet-sku-wise",
    postBody,
  });
};
